module.exports = __webpack_public_path__ + "static/media/sanditruck.75bde113.jpg";